module.exports = __webpack_public_path__ + "img/Image2.fc58c0b6.jpg";